<div class="row" style="max-width: 90%; margin: 0 auto; text-align: center;">
    <div class="col-sm-12">
        <div>
            <h3 class="page-label">Status: {{ getDisplayState(currentState?.state) }}</h3>
            <div class="row" *ngIf="currentState?.attempt">
              <div class="col-sm-4">
                <h4 class="page-label" style="text-align: left;">Selected Chamber: {{ service?.name }}</h4>
              </div>
              <div class="col-sm-4">
                <h4 class="page-label" style="text-align: left;">Case #: {{ currentState?.attempt?.case_number }}</h4>
              </div>
              <div class="col-sm-4">
                <h4 class="page-label" style="text-align: left;">Tunnel Reader: {{ currentState?.attempt?.tunnel_reader_name }}</h4>
              </div>
            </div>
            <div class="row" *ngIf="currentState?.attempt">
              <div class="col-sm-4">
                <h4 class="page-label" style="text-align: left;">Barcode: {{ currentState?.attempt?.scanned_barcode }}</h4>
              </div>
              <div class="col-sm-4">
                <h4 class="page-label" style="text-align: left;">Carton #: {{ currentState?.attempt?.carton_number }}</h4>
              </div>
              <div class="col-sm-4">
                <h4 class="page-label" style="text-align: left;">Tunnel Read TS: {{ currentState?.attempt?.tunnel_read_timestamp }}</h4>
              </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isDisplayState_EnterInfo()" class="row" style="max-width: 90%; margin: 0 auto; text-align: center;">
    <label class="col-sm-3 input-label" for="portal-input">Barcode:</label>
    <div class="printer-input col-sm-9">
        <div class="row">
            <input #cartonIdField class="form-control" type="text" [(ngModel)]="cartonId" (keydown.enter)="enterCartonId()" autofocus />
        </div>
    </div>
</div>


<ng-container *ngIf="currentState?.attempt">
    <table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table" role="grid" style="max-width: 90%; margin-left: auto; margin-right: auto;">
      <thead>
        <tr role="row" class="tablesorter-headerRow">
          <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
            <div class="tablesorter-header-inner">UPC</div>
          </th>
          <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
            <div class="tablesorter-header-inner">SKU</div>
          </th>
          <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
            <div class="tablesorter-header-inner">STYLE</div>
          </th>
          <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
            <div class="tablesorter-header-inner">SIZE</div>
          </th>
          <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
            <div class="tablesorter-header-inner">COLOR</div>
          </th>
          <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
            <div class="tablesorter-header-inner" *ngIf="currentState.attempt.use_sku_quantity">SKU QTY *</div>
            <div class="tablesorter-header-inner" *ngIf="!currentState.attempt.use_sku_quantity">SKU QTY</div>
          </th>
          <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
            <div class="tablesorter-header-inner" *ngIf="!currentState.attempt.use_sku_quantity">RFID EXP QTY *</div>
            <div class="tablesorter-header-inner" *ngIf="currentState.attempt.use_sku_quantity">RFID EXP QTY</div>
          </th>
          <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
            <div class="tablesorter-header-inner">TUNNEL QTY</div>
          </th>
          <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
            <div class="tablesorter-header-inner">CHAMBER QTY</div>
          </th>
          <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
            <div class="tablesorter-header-inner"># VARIANCE</div>
          </th>
          <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
            <div class="tablesorter-header-inner">AUDIT QTY</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr role="row" *ngFor="let lineItem of currentState?.attempt?.line_items; index as i;" [class.green-highlight]="isSuccessRow(lineItem)" [class.red-highlight]="isErrorRow(lineItem)" [class.yellow-highlight]="isPartialRow(lineItem)" [class.gray-highlight]="isUnknownRow(lineItem)">
          <!-- UPC -->
          <td>
            {{ lineItem?.upc }}
          </td>
          <!-- SKU -->
          <td>
            {{ lineItem?.sku }}
          </td>
          <!-- STYLE -->
          <td>
            {{ lineItem?.style }}
          </td>
          <!-- SIZE -->
          <td>
            {{ lineItem?.size }}
          </td>
          <!-- COLOR -->
          <td>
            {{ lineItem?.color }}
          </td>
          <!-- SKU QTY -->
          <td>
            {{ lineItem?.sku_quantity }}
          </td>
          <!-- RFID EXP QTY -->
          <td>
            {{ lineItem?.rfid_expected_quantity }}
          </td>
          <!-- TUNNEL QTY -->
          <td>
            {{ lineItem?.tunnel_quantity }}
          </td>
          <!-- CHAMBER QTY -->
          <td>
            {{ lineItem.scanned_quantity }}
          </td>
          <!-- # VARIANCE -->
          <td>
            {{ lineItem.required_quantity - getAuditQuantity(lineItem) }}
          </td>
          <!-- AUDIT QUANTITY -->
          <td>
          <!-- <td style="cursor: pointer" (click)="onAuditQuantityClicked(lineItem)"> -->
            {{ getAuditQuantity(lineItem) }}
          </td>
        </tr>
      </tbody>
    </table>

    <div class="row" style="max-width: 90%; margin-left: auto; margin-right: auto;">
      <div class="col-xs-6">
        <!-- <button class="submit btn btn-default" (click)="onReasonCodeAndCommentClicked()" [disabled]="isProcessingAction">Add Reason Code / Comment</button> -->
      </div>
      <div class="col-xs-6 text-right">
        <div class="right-aligned-row">
          <button class="submit btn btn-default" (click)="onClearCartonClicked()" [disabled]="isProcessingAction">Clear Carton</button>
          <button class="submit btn btn-primary" (click)="onProcessCartonClicked()" [disabled]="isProcessingAction">Process Carton</button>
        </div>
      </div>
    </div>

    <div class="row" style="max-width: 90%; margin-left: auto; margin-right: auto;">
      <br/>
      <br/>
    </div>
</ng-container>



<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog></ef-simple-indefinite-progress-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box></ef-simple-success-error-dialog-box>

<ef-pvh-reason-code-dialog
  [availableReasonCodeOptions]="availableReasonCodeOptions"
  [selectedReasonCode]="enteredReasonCodeAndComment?.reasonCode"
  [comment]="enteredReasonCodeAndComment?.comment"
  (userEnteredValues)="userEnteredReasonCodeAndComment($event)"
  ></ef-pvh-reason-code-dialog>


<ef-pvh-audit-quantity-dialog
  [availableReasonCodeOptions]="availableReasonCodeOptions"
  (userEnteredValues)="onAuditQuantityResult($event)"
  ></ef-pvh-audit-quantity-dialog>